const StatCard = ({ icon: Icon, label, value, color, testId }) => (
  <div data-testid={testId}
    className="bg-white border border-slate-200 rounded-none shadow-sm hover:shadow-md transition-shadow duration-300 p-6">
    <div className="flex items-center justify-between mb-4">
      <Icon size={32} weight="duotone" style={{ color }} />
    </div>
    <div className="text-3xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif', color }}>
      {value}
    </div>
    <div className="text-sm text-slate-600">{label}</div>
  </div>
);

const ProgressBar = ({ label, value, total, color }) => (
  <div>
    <div className="flex justify-between mb-2">
      <span className="text-sm text-slate-600">{label}</span>
      <span className="text-sm font-bold" style={{ color }}>{value}</span>
    </div>
    <div className="w-full bg-slate-200 h-2">
      <div className="h-2 transition-all duration-300" style={{ width: `${total ? (value / total * 100) : 0}%`, backgroundColor: color }}></div>
    </div>
  </div>
);

const ActivityItem = ({ activity, index }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'call': return '//';
      case 'email': return '@';
      case 'meeting': return '[]';
      default: return '#';
    }
  };
  return (
    <div className="flex items-start gap-3 pb-3 border-b border-slate-100 last:border-0">
      <div className="w-8 h-8 flex items-center justify-center bg-slate-100 border border-slate-200 rounded-none text-xs font-bold text-slate-600">
        {getIcon(activity.type)}
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium capitalize">{activity.type}</p>
        <p className="text-xs text-slate-600 mt-1">{activity.description}</p>
        <p className="text-xs text-slate-400 mt-1">
          {activity.contact_name && `${activity.contact_name} `}
          {activity.created_at && new Date(activity.created_at).toLocaleString()}
        </p>
      </div>
    </div>
  );
};

export { StatCard, ProgressBar, ActivityItem };
